const REMEMBERED_LOGIN_KEY = '@higa:rememberedLogin'

export interface IRememberedLogin {
	enrollment: string
	documentNumber: string
}

export function getRememberedLogin(): IRememberedLogin | null {
	try {
		const stored = localStorage.getItem(REMEMBERED_LOGIN_KEY)

		if (!stored) return null

		const parsed = JSON.parse(stored)

		if (
			typeof parsed?.enrollment !== 'string' ||
			typeof parsed?.documentNumber !== 'string'
		) {
			return null
		}

		return {
			enrollment: parsed.enrollment,
			documentNumber: parsed.documentNumber,
		}
	} catch {
		return null
	}
}

export function setRememberedLogin(data: IRememberedLogin): void {
	try {
		localStorage.setItem(REMEMBERED_LOGIN_KEY, JSON.stringify(data))
	} catch {}
}

export function clearRememberedLogin(): void {
	try {
		localStorage.removeItem(REMEMBERED_LOGIN_KEY)
	} catch {}
}
